(function () {
    'use strict';

    angular
        .module('platformApp')
        .controller('PictureShareModalController', PictureShareModalController);

    PictureShareModalController.$inject = ['$scope', '$uibModalInstance', '$state', '$stateParams', 'MessageService', 'Catalog', 'entity', 'PicLayoutXmls'];

    function PictureShareModalController($scope, $uibModalInstance, $state, $stateParams, MessageService, Catalog, entity, PicLayoutXmls) {

        var vm = this;
        vm.PicLayoutXmlIds = entity;
        console.log(entity,'entity');

        vm.clear = clear;
        vm.save = save;
        vm.label = ''

        vm.catalogs = Catalog.getAll2({items:[{key:"usable",op:"=",value:"true"},{key:"catalogType",op:"=",value:"LAYOUT"}]})


        function clear() {
            $uibModalInstance.dismiss('cancel');
        }


        $scope.validate = function () {
            if (vm.backCatalog == null || vm.backCatalog == "") {
                MessageService.error("请选择专题");
                return false;
            }
            return true;
        };

        function save() {
            // $uibModalInstance.dismiss('cancel');
            if (!$scope.validate()) {
                return;
            }
            PicLayoutXmls.batchShare({ids:vm.PicLayoutXmlIds, catalogId:vm.backCatalog},function(data){
                MessageService.success("分享成功,等待后台审核");
                $uibModalInstance.close(data);
            },function(){

                MessageService.error("分享失败");
            });
        }

    }

})();
